/*
 * Shared broker-list ordering.
 *
 * Broker lists come straight off a DynamoDB scan (bd-<companyId>-brokers), so
 * without an explicit sort they render in arbitrary hash order. Every picker
 * that lets someone choose a broker sorts by surname — the way you'd look a
 * person up on a list.
 */
export function sortBrokersBySurname(brokers) {
    return [...brokers].sort((a, b) => {
        const surname = (a.lastName || '').toLowerCase().localeCompare((b.lastName || '').toLowerCase())
        if (surname !== 0) return surname
        return (a.firstName || '').toLowerCase().localeCompare((b.firstName || '').toLowerCase())
    })
}
